import { configureStore, combineReducers } from "@reduxjs/toolkit"
import globalReducer from "./reducer/GlobalReducer";
import assetsReducer from "./reducer/assets/AssetsReducer"
import dashboardReducer from "./reducer/dashboard/DashboardReducer"
import masterReducer from "./reducer/master/masterReducer"
import settingsReducer from "./reducer/settings/settingsReducer"
import usersReducer from "./reducer/users/usersReducer"
import companyReducer from "./reducer/company/CompanyReducer"
import onlineClassReducer from "./reducer/online_class/onlineClassReducer";
import assignReducer from "./reducer/assign/assignReducer";
import assignmentReducer from "./reducer/assignment/assignmentReducer";
import paperGenerationReducer from "./reducer/paperGenerationReducer";
import classReducer from "./reducer/class/classReducer";
import dayReducer from "./reducer/day/dayReducer";
import registrationReducer from "./reducer/registration/registrationReducer";
import paymentReducer from "./reducer/payment/paymentReducer";
import paymentHistoryReducer from "./reducer/payment_history/paymentHistoryReducer";
import studentExamReducer from "./reducer/student_exam/studentExamReducer";

const rootReducer = combineReducers({
    ...globalReducer,
    ...assetsReducer,
    ...dashboardReducer,
    ...masterReducer,
    ...settingsReducer,
    ...usersReducer,
    ...companyReducer,
    ...onlineClassReducer,
    ...assignReducer,
    ...assignmentReducer,
    ...paperGenerationReducer,
    ...classReducer,
    ...dayReducer,
    ...registrationReducer,
    ...paymentReducer,
    ...paymentHistoryReducer,
    ...studentExamReducer,
});

const lms_store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export default lms_store;